import { Fragment } from 'react';
import { ReviewProgress, ReviewFeedback } from 'app/domains/review';
export function Review() {
    return (<Fragment>
      <ReviewProgress />
      <ReviewFeedback />
    </Fragment>);
}
